module.exports = __webpack_public_path__ + "static/media/4_no_verde.72f38624.png";